import { parseServerDate } from '@ott/utility-date';
import _isEmpty from 'lodash/isEmpty';
import store from 'store';
import { LAST_SEARCH_KEY } from '../consts';
import decodeLocation from './decodeLocation';

export function getInitialValuesFromURL(query) {
  if (!query || !query.pLocation) {
    return {};
  }

  const { pDate, dDate, pTime, dTime, age, pLocation, dLocation, pKey, dKey } = query;

  return {
    pickUpDate: pDate ? { startDate: parseServerDate(pDate) } : {},
    pickUpTime: pTime ? `${pTime.slice(0, 2)}:${pTime.slice(2)}` : '',
    dropOffDate: dDate ? { startDate: parseServerDate(dDate) } : {},
    dropOffTime: dTime ? `${dTime.slice(0, 2)}:${dTime.slice(2)}` : '',
    pickUp: pLocation ? decodeLocation(pLocation) : '',
    dropOff: dLocation ? decodeLocation(dLocation) : '',
    age,
    pKey,
    dKey,
  };
}

export function getInitialValuesFromLocalStorage() {
  const valuesFromStorage = store.get(LAST_SEARCH_KEY);

  if (_isEmpty(valuesFromStorage)) {
    return {};
  }

  const {
    pickUpDate: { startDate: pickUpDate },
    dropOffDate: { startDate: dropOffDate },
    ...rest
  } = valuesFromStorage;

  return {
    pickUpDate: { startDate: new Date(pickUpDate) },
    dropOffDate: { startDate: new Date(dropOffDate) },
    ...rest,
  };
}
